

/*import { createToaster } from "@meforma/vue-toaster";*/
import axiosInstance from "./externalapi";

const setup = (store) => {
    axiosInstance.interceptors.request.use(
        (config) => {
                    config.headers["Content-Type"] = "application/json",
                    config.headers['Access-Control-Allow-Origin'] = '*',
                    config.headers['Access-Control-Allow-Methods'] = 'GET,POST, PATCH,PUT,DELETE,OPTIONS',
                    config.headers['Access-Control-Allow-Headers'] = 'Origin, Content-Type, X-Auth-Token',
                    config.headers['Cache-Control'] = 'no-cache'

            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    axiosInstance.interceptors.response.use(
        (res) => {
            return res;
        },
        async (err) => {
            const originalConfig = err.config;
            return Promise.reject(err);
        }
    );
};

export default setup;